// The visible editor toggle is authoritative; older campaigns use the legacy flag.
export const personalisationVisible = (explicit, legacy) => (
  typeof explicit === "boolean" ? explicit : !!legacy
);

export const socialShareUrl = (text, config = {}) => {
  config = config || {};
  const params = new URLSearchParams();
  if (config.x_post_type === "quote_tweet") {
    if (!config.x_quote_tweet_url) return undefined;
    params.set("text", `${text} ${config.x_quote_tweet_url}`.trim());
  } else {
    params.set("text", text);
    if (config.x_post_type === "reply") {
      const id = (config.x_quote_tweet_url || "").match(/status\/(\d+)/)?.[1];
      if (!id) return undefined;
      params.set("in_reply_to", id);
    }
  }
  return `https://twitter.com/intent/tweet?${params.toString()}`;
};